<script>
import BaseSummaryStep from '../SubmitStep'
import { dateFormatter, lang, salaryFormatter } from '../../utils'

export default {
  extends: BaseSummaryStep,

  methods: {
    formAsPayload () {
      let formData = new FormData()
      formData.append('data', JSON.stringify({
        salutation: this.form.salutation,
        first_name: this.form.first_name,
        last_name: this.form.last_name,
        street: `${this.form.street} ${this.form.house_number}`,
        postal: this.form.postal,
        city: this.form.city,
        phone: this.form.telephone_number,
        email: this.form.email,
        title: '',
        questions: [
          {
            label: lang.qualifications,
            answer: this.form.qualifications.join(', '),
          },
          {
            label: lang.linquistic_proficiency,
            answer: [...this.form.languages, this.form.language_others].filter(i => i).join(', '),
          },
          {
            label: lang.possible_start_of_work,
            answer: dateFormatter(this.form.start_of_work),
          },
          {
            label: lang.salary_expectations,
            answer: salaryFormatter(this.form.expected_salary),
          },
          {
            label: lang.additional_information,
            answer: this.form.additional_information,
          },
        ],
      }))

      if (this.form.file_upload instanceof FileList) {
        formData.append('file', this.form.file_upload[0])
      }

      return formData
    }
  }
}
</script>